import { createWealthForumPrompt } from './wealth-landscape-forum';
import { createChubbPrompt } from './chubb-payment-reminder';
import { createPrudentialPrompt } from './prudential-annual-checkin';
import { createGrabRestaurantPrompt } from './grab-restaurant-onboarding';

export const getScriptPrompt = (
  scriptId: string,
  scriptMessage: string,
  scriptNodes: any
) => {
  switch (scriptId) {
    case 'wealth-landscape-forum':
      return createWealthForumPrompt(scriptMessage, scriptNodes);

    case 'grab-restaurant-onboarding':
      return createGrabRestaurantPrompt(scriptMessage, scriptNodes);

    case 'chubb-payment-reminder':
      return createChubbPrompt(scriptMessage, scriptNodes);

    case 'prudential-annual-checkin':
    default:
      return createPrudentialPrompt(scriptMessage, scriptNodes);
  }
};

export {
  createWealthForumPrompt,
  createChubbPrompt,
  createPrudentialPrompt,
  createGrabRestaurantPrompt,
};
